import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const baseUrl = 'https://www.praxismandt.de'
const apiBaseUrl = baseUrl + '/cockpit/api'
const apiKey = '?token=639109f86fca5a7630bb7849e7e9ff'
const fallbackData = require('../config/testdaten')

const client = {
  getSingletonUrl: (name) => {
    return apiBaseUrl + '/singletons/get/' + name
  },
  getCollectionUrl: (name) => {
    return apiBaseUrl + '/collections/get/' + name
  }
}

export default new Vuex.Store({
  state: {
    serviceClient: client,
    baseUrl,
    apiKey,
    loading: true,
    settings: fallbackData.pageSettings,
    menu: fallbackData.mainMenu,
    subMenu: [] // fallbackData.subMenu
  },
  getters: {
    serviceClient (state) {
      return () => state.serviceClient
    },
    baseUrl (state) {
      return () => state.baseUrl
    },
    apiBaseUrl (state) {
      return () => state.apiBaseUrl
    },
    apiKey (state) {
      return () => state.apiKey
    },
    settings (state) {
      return () => state.settings
    },
    menu (state) {
      return () => state.menu
    },
    subMenu (state) {
      return () => state.subMenu
    }
  },
  mutations: {
    setSettings (state, payload) {
      state.settings = payload
    },
    setMenu (state, payload) {
      state.menu = payload
    },
    setSubMenu (state, payload) {
      state.subMenu = payload
    }
  },
  actions: {
    loadSettings (context) {
      console.log('loadSettings')
      Vue.http.get(client.getSingletonUrl('settings'))
        .then((response) => {
          console.log(response.body)
          if (response.ok) {
            context.commit('setSettings', response.body)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadMenu (context) {
      Vue.http.get(client.getCollectionUrl('mainMenu'))
        .then((response) => {
          if (response.ok) {
            console.log(response.body.entries)
            context.commit('setMenu', response.body.entries)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadSubMenu (context) {
      Vue.http.get(client.getCollectionUrl('subMenu'))
        .then((response) => {
          console.log(response.body.entries)
          context.commit('setSubMenu', response.body.entries)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js